"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ECurrentErrorField = exports.EActionTypes = void 0;
let EActionTypes = exports.EActionTypes = /*#__PURE__*/function (EActionTypes) {
  EActionTypes["SET_ADDRESS"] = "MainFilters/SetAddress";
  EActionTypes["SET_ROOMS"] = "MainFilters/SetRooms";
  EActionTypes["SET_JK_ROOMS"] = "MainFilters/SetJkRooms";
  EActionTypes["SET_AREA"] = "MainFilters/SetArea";
  EActionTypes["SET_ERROR"] = "MainFilters/SetError";
  EActionTypes["SET_USER_AREA_FLAG"] = "MainFilters/SetUserAreaFlag";
  EActionTypes["SET_USER_ROOMS_COUNT_FLAG"] = "MainFilters/SetUserRoomsCountFlag";
  EActionTypes["SET_ESTIMATION_TARGET"] = "MainFilters/SetEstimationTarget";
  EActionTypes["SET_NEWBUILDING_ID"] = "MainFilters/SetNewbuildingId";
  EActionTypes["SET_HOUSE_ID"] = "MainFilters/SetHouseId";
  EActionTypes["RESET_FILTERS"] = "MainFilters/ResetFilters";
  EActionTypes["SET_LAND_AREA"] = "MainFilters/SetLandArea";
  EActionTypes["SET_HOUSE_AREA"] = "MainFilters/SetHouseArea";
  EActionTypes["SET_FLAT_NUMBER"] = "MainFilters/SetFlatNumber";
  return EActionTypes;
}({});
/** Payload для фильтра адреса (геосаджест)*/
/** Payload для фильтра площади */
/** Payload для фильтра Номера квартиры */
/** Payload для фильтра Комнатности */
/** Payload для фильтра Комнатности для страницы ЖК */
/** Payload для установки ошибки */
let ECurrentErrorField = exports.ECurrentErrorField = /*#__PURE__*/function (ECurrentErrorField) {
  ECurrentErrorField["none"] = "";
  ECurrentErrorField["address"] = "address";
  ECurrentErrorField["roomsCount"] = "roomsCount";
  ECurrentErrorField["area"] = "area";
  ECurrentErrorField["houseArea"] = "houseArea";
  ECurrentErrorField["landArea"] = "landArea";
  ECurrentErrorField["flatNumber"] = "flatNumber";
  return ECurrentErrorField;
}({});
/** Payload для установки флага, значащего что юзер вручную ввел площадь в фильтр */
/** Payload для установки флага, значащего что юзер вручную ввел комнатность в фильтр */
/** Payload для установки фильтра "Тип оцениваемого объекта" */
/** Payload для установки ID новостройки (не вводится юзером, но ставится при клике на итем из геосаджеста ЖК */
/** Payload для установки ID квартиры (не вводится юзером, но возвращается при успешной валидации адреса */